import one from '../../../../assets/images/job-search/1.jpg';
import { UIDesigner, EndlessTelecom, Submit, Cancel, Savethisjob } from '../../../../Constant';
import { Btn, P, Image, H5, UL, LI } from '../../../../AbstractElements';
import PersonalDetail from './PersonalDetail';
import EducationClass from './Education';
import ExperienceClass from './Experience';
import UploadFileClass from './UploadFile';
import React, { Fragment } from 'react';
import { Col, Card, CardBody, CardFooter } from 'reactstrap';

const JobApply = () => {
  return (
    <Fragment>
      <Col xxl='9' xl='8' className='box-col-70'>
        <Card>
          <div className='job-search'>
            <CardBody className='pb-0'>
              <div className='d-sm-flex align-items-start'>
                <Image className='img-40 img-fluid mx-auto m-sm-r-20' src={one} alt='' />
                <div className='flex-grow-1'>
                  <H5 className='f-w-700 mb-0'>
                    <a href='#javascript'>{UIDesigner}</a>
                  </H5>
                  <P>{EndlessTelecom}</P>
                  <UL className='rating simple-list'>
                    <LI>
                      <i className='fa fa-star font-warning me-1'></i>
                    </LI>
                    <LI>
                      <i className='fa fa-star font-warning me-1'></i>
                    </LI>
                    <LI>
                      <i className='fa fa-star font-warning me-1'></i>
                    </LI>
                    <LI>
                      <i className='fa fa-star font-warning me-1'></i>
                    </LI>
                    <LI>
                      <i className='fa fa-star font-warning m-0'></i>
                    </LI>
                  </UL>
                  <Btn color='primary' className='job-apply-btn'>
                    <span>
                      <i className='fa fa-check text-white'></i>
                    </span>
                    {Savethisjob}
                  </Btn>
                </div>
              </div>
              <div className='job-description'>
                <PersonalDetail />
                <EducationClass />
                <ExperienceClass />
                <UploadFileClass />
              </div>
            </CardBody>
            <CardFooter>
              <Btn color='primary me-1'>{Submit}</Btn>
              <Btn color='light'>{Cancel}</Btn>
            </CardFooter>
          </div>
        </Card>
      </Col>
    </Fragment>
  );
};

export default JobApply;
